var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2C12.09 2 15 4.91005 15 8.5C15 12.09 12.09 15 8.5 15C4.91005 15 2 12.09 2 8.5C2 4.91005 4.91005 2 8.5 2ZM8.5 10.45C8.32761 10.45 8.16228 10.5185 8.04038 10.6404C7.91848 10.7623 7.85 10.9276 7.85 11.1C7.85 11.2724 7.91848 11.4377 8.04038 11.5596C8.16228 11.6815 8.32761 11.75 8.5 11.75C8.67239 11.75 8.83772 11.6815 8.95962 11.5596C9.08152 11.4377 9.15 11.2724 9.15 11.1C9.15 10.9276 9.08152 10.7623 8.95962 10.6404C8.83772 10.5185 8.67239 10.45 8.5 10.45ZM8.5 4.6C8.34079 4.60002 8.18713 4.65847 8.06816 4.76426C7.94919 4.87006 7.87318 5.01584 7.85455 5.17395L7.85 5.25V9.15C7.85018 9.31567 7.91362 9.47502 8.02735 9.59549C8.14108 9.71596 8.29652 9.78845 8.46191 9.79816C8.62729 9.80787 8.79015 9.75406 8.91719 9.64773C9.04424 9.54139 9.12588 9.39056 9.14545 9.22605L9.15 9.15V5.25C9.15 5.07761 9.08152 4.91228 8.95962 4.79038C8.83772 4.66848 8.67239 4.6 8.5 4.6Z",
    fill: "#6C757D",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningGrey);
export default __webpack_public_path__ + "static/media/warningGrey.a4a49261a5340437da0e30894db27b31.svg";
export { ForwardRef as ReactComponent };